var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEstrellaPuntos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0007,
    cy: 22.4997,
    r: 14.6667,
    fill: "#FCED55"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.5,
    r: 11,
    fill: "#E5B845"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9993 15.167L23.6989 17.2695L26.3098 16.5675L26.4489 19.2675L28.9738 20.2342L27.4993 22.5003L28.9738 24.7665L26.4489 25.7331L26.3098 28.4331L23.6989 27.7311L21.9993 29.8337L20.2998 27.7311L17.6889 28.4331L17.5498 25.7331L15.0249 24.7665L16.4993 22.5003L15.0249 20.2342L17.5498 19.2675L17.6889 16.5675L20.2998 17.2695L21.9993 15.167Z",
    fill: "#FCED55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrellaPuntos);
export default __webpack_public_path__ + "static/media/estrellaPuntos.b51c285cc3195d5ae225be2fdc6a6424.svg";
export { ForwardRef as ReactComponent };